"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("../hooks/react");

var _Debug = _interopRequireDefault(require("../context/Debug"));

var _logger = _interopRequireDefault(require("../utils/logger"));

/**
 *
 * @param {Boolean} debugger
 */
var useDebugLogger = function useDebugLogger() {
  var debug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useContext = (0, _react.useContext)(_Debug["default"]),
      debugContext = _useContext.debug;

  return (0, _logger["default"])({
    isOn: debug || debugContext
  });
};

var _default = useDebugLogger;
exports["default"] = _default;